import React, { useCallback, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import * as S from './style';
import { Label, ProfileImage } from 'components';
import { BaseTemplate } from 'pages';
import { PartnerAuthState } from 'stores/PartnerAuthStore';

import { ReactComponent as IconModify } from 'assets/img/profile/ic_profile_modify.svg';
import { MY_PROFILE } from 'router/PageUrl';

interface Props {
    children: React.ReactNode;
    title?: string;
    serviceIdx: number;
    serviceType: string;
    isBackBtn?: boolean;
}

function TemplateWithProfile({ children, title, serviceIdx, serviceType, isBackBtn }: Props): React.ReactElement {
    const history = useHistory();
    const { profileImage } = useContext(PartnerAuthState);
    const onClickCallback = useCallback(
        (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
            history.push(`${MY_PROFILE.url}/${serviceType}/${serviceIdx}`);
        },
        [history, serviceIdx, serviceType]
    );

    return (
        <BaseTemplate isBackBtn={isBackBtn}>
            <S.ContentsContainer>
                <S.TitleWrapper>
                    <Label contents={title} color={'gray_opacity_800'} fontStyle={'h3_bold'} />
                    <S.ProfileWrapper>
                        <ProfileImage size={'S'} background={profileImage ? profileImage : ''} icon={<IconModify />} onClick={onClickCallback} />
                    </S.ProfileWrapper>
                </S.TitleWrapper>
                {children}
            </S.ContentsContainer>
        </BaseTemplate>
    );
}

export default TemplateWithProfile;
